<template>
    <div class="survey-analytics">
        <div class="survey-page-info">
            <h4>Survey Overview</h4>
            <div class="survey-page-stats">
                <router-link class="survey-page-stat" :to="{name: 'surveys-details-questions', params: {survey_id: survey.id} }">
                    <div class="stat-number">{{ survey.questions_count || 0 }}</div>
                    <div class="stat-label">Questions</div>
                </router-link>
                <router-link class="survey-page-stat" :to="{name: 'surveys-details-responses', params: {survey_id: survey.id} }">
                    <div class="stat-number">{{ survey.responses_count || 0 }}</div>
                    <div class="stat-label">Views</div>
                </router-link>
                <router-link class="survey-page-stat" :to="{name: 'surveys-details-responses', params: {survey_id: survey.id} }">
                    <div class="stat-number">{{ survey.started_responses_count || 0 }}</div>
                    <div class="stat-label">Responses</div>
                </router-link>
                <router-link class="survey-page-stat financial" :to="{name: 'surveys-details-results', params: {survey_id: survey.id} }" v-tooltip="'How many people answered at least one question.'">
                    <div class="stat-number">
                        {{ survey.responses_count ? Math.round(survey.started_responses_count / survey.responses_count * 100) : 0 }}%
                    </div>
                    <div class="stat-label">Engagement Rate</div>
                </router-link>
                <router-link class="survey-page-stat financial" :to="{name: 'surveys-details-results', params: {survey_id: survey.id} }" v-tooltip="'How many people completely finished the survey.'">
                    <div class="stat-number">
                        {{ survey.responses_count ? Math.round(survey.complete_responses_count / survey.responses_count * 100) : 0 }}%
                    </div>
                    <div class="stat-label">Completion Rate</div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SurveyAnalytics",
    props: {
        survey: {
            type: Object,
            required: true,
        }
    }
}
</script>
